import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef, MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatCheckbox} from "@angular/material/checkbox";
import {RoleService} from "../../../../../services/apps/role/role.service";
import {MatButton, MatIconButton} from "@angular/material/button";
import {TablerIconsModule} from "angular-tabler-icons";
import {MatTooltip} from "@angular/material/tooltip";
import {MatPaginator} from "@angular/material/paginator";
import {NgIf} from "@angular/common";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ToastrService} from "ngx-toastr";
import {LocalizationPipe} from "../../../../../pipe/localization-pipe";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-role-management-list-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatCheckbox,
    MatHeaderRow,
    MatRow,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatIconButton,
    TablerIconsModule,
    MatTooltip,
    MatDialogActions,
    MatButton,
    MatPaginator,
    NgIf,
    MatProgressSpinner,
    MatNoDataRow,
    LocalizationPipe,
    FormsModule
  ],
  templateUrl: './role-management-list-dialog.component.html',
  styleUrl: './role-management-list-dialog.component.scss'
})
export class RoleManagementListDialogComponent implements OnInit {

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns = ['code', 'description'];
  organisationId: number;
  roleId: number;
  roleName: string;
  allAuthorizationCodes: any[] = [];
  totalElements: number;
  pageSize: number = 10;
  currentPage: number = 0;
  isDataLoading: boolean = false;
  selectedAuthorizationCodes: any[] = [];
  paginatedData: any[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private roleService: RoleService, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<RoleManagementListDialogComponent>,
              private toastService: ToastrService) {
    this.roleId = data.roleId;
    this.roleName = data.roleName;
    this.organisationId = data.organisationId;
  }

  ngOnInit(): void {
    this.setDataSource();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.page.subscribe((event) => {
        this.onPageChange(event);
      });
    }
  }

  setDataSource() {
    this.isDataLoading = true;

    this.roleService.getAuthorizationCodes(
      this.organisationId == undefined ? null : this.organisationId, { roleId: this.roleId }).subscribe({
      next: (res: any) => {
        const responseData = res?.data;
        this.allAuthorizationCodes = responseData?.content || responseData || [];
        this.totalElements = this.allAuthorizationCodes.length;
        const newlySelected = this.allAuthorizationCodes
          .filter((code: any) => code.selected)
          .map((code: any) => code.codeId);
        this.selectedAuthorizationCodes = Array.from(new Set([
          ...this.selectedAuthorizationCodes,
          ...newlySelected
        ]));

        this.prepareData();
        this.updatePaginatedData();
        this.isDataLoading = false;
      },
      error: error => {
        this.isDataLoading = false;
      }
    });
  }

  prepareData() {
    this.dataSource.data = this.allAuthorizationCodes.map((code: any) => {
      return {
        code: code?.code || '',
        description: code?.description || '',
        selected: this.selectedAuthorizationCodes.includes(code?.codeId),
        codeId: code?.codeId
      };
    });
  }

  updatePaginatedData() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.dataSource.data.slice(startIndex, endIndex);
  }

  toggleAuthorizationCode(codeId: number, isSelected: boolean) {
    const idx = this.selectedAuthorizationCodes.indexOf(codeId);
    if (isSelected && idx === -1) {
      this.selectedAuthorizationCodes.push(codeId);
    } else if (!isSelected && idx !== -1) {
      this.selectedAuthorizationCodes.splice(idx, 1);
    }

    const currentItem = this.dataSource.data.find((item: any) => item.codeId === codeId);
    if (currentItem) {
      currentItem.selected = isSelected;
    }
  }

  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updatePaginatedData();
  }

  saveAuthorizationCodes() {
    this.roleService.setRoleToAuthorizationCode(this.organisationId, this.roleId, this.selectedAuthorizationCodes).subscribe({
      next: (res: any) => {
        this.toastService.success("Authorization codes added successfully.")
        this.closeDialog();
      },
      error: error => {
        this.toastService.error("An error occurred while saving the authorization codes. Please try again later.")
      }
    })
  }

  closeDialog() {
    // Memory cleanup
    this.selectedAuthorizationCodes = [];
    this.allAuthorizationCodes = [];
    this.dataSource.data = [];
    this.paginatedData = [];
    this.dialogRef.close();
  }
}
